module.exports = __webpack_public_path__ + "static/media/email.c54ddeb7.svg";